export interface CartResponse {
  isIntegrationTurnedOn: boolean;
  isAccountOnHoldDueInactivity: boolean;
  isTCChecked: boolean;
  termsAndConditions?: string;
  customerName?: string;
  warehouseCode?: string;
  warehouseEmail?: string;
  contactPhoneNumber?: string;
  hasOnlyPickup: boolean;
  hideCheckoutButton: boolean;
  disableCheckoutButton: boolean;
  disableCheckoutButtonText: string;
  subTotal: number;
  discount: number;
  coupon?: Discount;
  pickupPoint?: PickupPoint;
  warnings?: string[];
  items?: CartItem[];
  shareEmails?: ShoppingCartUser[];
  holidays: string[];
}

export interface CartItem {
  id: number;
  sku: string;
  productName: string;
  productId: number;
  parentProductId?: number;
  uom?: string;
  unitUom?: string;
  color?: string;
  colorHex?: string;
  measure?: string;
  picture?: Picture;
  quantity: number;
  unitPrice: number;
  unitPriceString?: string;
  subTotal: number;
  discount?: string;
  maximumDiscountedQty?: number | null;
  inventoryStatus?: InventoryStatus;
  discontinued: boolean;
  availabilityMessage?: string;
  isAvailable: boolean;
  isPublished: boolean;
  cartSpecificationLine: boolean;
  riserPan: boolean;
  box?: string;
  rib?: string;
  warnings?: string[];
  manufacturers?: string[];
  cartSpecificationLines?: CartSpecificationLine[];
  associatedProductsAttributes?: ColorMeasure[];
  associatedMeasureProductsAttributes?: ColorMeasure[];
  sapProduct: string | null;
}

export interface ShoppingCartUser {
  id: number;
  email: string;
}

export interface Discount {
  errorMessage?: string;
  messages?: string[];
  couponCodes?: CouponCode[];
}

export interface CouponCode {
  id: number;
  couponCode: string;
}

export interface PickupPoint {
  id: string;
  name: string;
  description?: string;
  providerSystemName?: string;
  address?: string;
  city?: string;
  county?: string;
  stateName?: string;
  countryName?: string;
  zipPostalCode?: string;
  latitude?: number | null;
  longitude?: number | null;
  pickupFee?: string;
  openingHours?: string[];
  contactPhoneNumber?: string;
  contactEmail?: string;
}

export interface Picture {
  imageUrl: string;
  thumbImageUrl: string;
  fullSizeImageUrl: string;
  title?: string;
  alternateText?: string;
  productId: number;
}

export interface CartSpecificationLine {
  id: number;
  displayOrder: number;
  qty: number;
  lengthFt: number;
  lengthIn: number;
}

export interface ColorMeasure {
  id: number;
  value: string;
  selected: boolean;
}

export interface RiserPan {
  box: string;
  rib: string;
}

export interface ShareShoppingCartRequest {
  recipients: number[];
  subject?: string;
  message?: string;
}

export enum InventoryStatus {
  InNetwork = 2, // "Stocked in Network"
  SpecialItem = 3, // "Special Order"
  OutOfStock = 4, // "Out Of Stock"
  Stocked = 5, // "Stocked"
  Available = 6, // "Available"
  ContactBranchForAvailability = 7, // "Contact Branch For Availability" && Contact Branch for Pricing
}
